import React, { ReactText, ChangeEvent, FormEvent } from 'react';
import ReasonForm from './components/ReasonForm';
import { Row, Layout, Heading } from 'elmo-elements';
import { ReasonHeading, Header, LayoutWrapper, FormBackdrop } from './style';
import headerLogoImg from '../Applications/assets/header-logo.svg';

export interface ITMSLoginReason {
  handleSelect: (value: ReactText) => void;
  isTextAreaDisplayed: boolean;
  submitEnabled: boolean;
  handleTextChange: (event: ChangeEvent<HTMLInputElement>) => void;
  otherText: string;
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
  error: string;
}

const TMSLoginReason: React.FC<ITMSLoginReason> = ({
  handleSelect,
  isTextAreaDisplayed,
  submitEnabled,
  handleTextChange,
  otherText,
  handleSubmit,
  error,
}: ITMSLoginReason) => {
  return (
    <Layout>
      <LayoutWrapper>
        <Layout.Content>
          <Header>
            <img src={headerLogoImg} alt="elmo hub" />
          </Header>
          <ReasonHeading>
            <Heading type="heading" align="center" htmlTag="h4">
              Why would you like to login?
            </Heading>
          </ReasonHeading>
          <Row alignContent="center" justifyContent="center">
            <FormBackdrop xs={12} md={6}>
              <ReasonForm
                handleSubmit={handleSubmit}
                handleSelect={handleSelect}
                isTextAreaDisplayed={isTextAreaDisplayed}
                submitEnabled={submitEnabled}
                handleTextChange={handleTextChange}
                otherText={otherText}
                error={error}
              />
            </FormBackdrop>
          </Row>
        </Layout.Content>
      </LayoutWrapper>
    </Layout>
  );
};

export default TMSLoginReason;
